export default import.meta.ROLLDOWN_FILE_URL_EOBvqV7QHO9ofF20TDGjNQ